import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutinesService } from '../../../../services/routines.service';
import { MyToasterService } from '../../../../services/my-toaster.service';
import { LoadingService } from '../../../../services/loading.service';

import { CommissionsAPI } from '../../../../api/commissions.api';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

//https://ng-bootstrap.github.io/#/components/modal/api


@Component({
	selector: 'commissions-modal-component',
	templateUrl: './commissions-modal.component.html',
	styleUrls: ['./commissions-modal.component.scss'],
})

export class CommissionsModalComponent {

	public comissao: any;
	public grid: any;
	public submitting: boolean = false;

	constructor(
		private activeModal: NgbActiveModal,
		private commissionsAPI: CommissionsAPI,
		private loadingService: LoadingService,
		private myToaster: MyToasterService) {
	}

	/**
	 * closeModal
	 *
	 * @public
	 * @author Murilo
	 * @since  01/2019
	 * @param {void}
	 * @return {void}
	 */
	public async salvarPagamento() {


		// Verifica se a comissão já foi paga
		if (this.comissao.IsComissaoPaga == 'S' || this.submitting)
			// Não faz nada
			return;

		this.submitting = true;

		// Mostra o loading
		this.loadingService.loadingContent = true;

		try {

			// Confirma a intenção do usuário
			if (confirm('Deseja indicar que o pagamento dessas comissões já foi pago? Esta ação não poderá ser desfeita')) {

				// Faz a requisição para a api
				await this.commissionsAPI.register_payment(this.comissao.ProcessoId);

				// Altera o status da tela
				this.comissao.IsComissaoPaga = 'S';

				// Atualiza o grid
				this.grid.source.refresh();

				// Mostra o toast de sucesso
				this.myToaster.showSuccessToast('Comissões salvas como pagas com sucesso');
			}
		} catch (err) {
			// Mostra o toast de erro
			this.myToaster.showSuccessToast('As comissões não foram salvas como pagas', err);
		}

		// Esconde o loading
		this.loadingService.loadingContent = false;
		this.submitting = false;
	}

	/**
	 * closeModal
	 *
	 * @public
	 * @author Murilo
	 * @since  01/2019
	 * @param {void}
	 * @return {void}
	 */
	public closeModal() {
		this.activeModal.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/commissions/modal/commissions-modal.component.ts